import axios from "../utils/http/axios";
import { DocumentType } from "../models";
//import { ToastProgrammatic as Toast, DialogProgrammatic as Dialog } from 'buefy';
import router from "../router";
import { useI18n } from "vue-i18n";
import { ServerName } from "../utils/constants/serverName";
import { Tenant, UserProfile } from "../models/user";
import { message } from "ant-design-vue";
//const i18n = useI18n();

/**
 * @returns Gets the list ofdocument types available for the specified tenant
 * @param {string} tenantId The Tenant, for which the document types have to be returned
 */

async function getDocumentTypesForTenant(tenantId: number): Promise<DocumentType[]> {
  return new Promise((resolve, reject) => {
    axios
      .get(`${ServerName}/doctype?tenant=${tenantId}`, {
        headers: {
          Accept: "application/json;charset=UTF-8",
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        //TODO: Write proper error message
        //   Dialog.alert({
        //     title: i18n.tc("annotationstool.document.load.error"),
        //     message: i18n.tc("error.reloadorcontactus"),
        //     type: "is-danger",
        //   });
        /*      logError({
            content: "Error  " + error + " while loading doctypes",
            actor: "",
          });
          */
      });
  });
}

export const postDocumentTypes = (tenantId: number, documentTypes: DocumentType[]): Promise<DocumentType[]> => {
  return new Promise((resolve, reject) => {
    axios
      .patch(`${ServerName}/doctype?tenant=${tenantId}`, documentTypes)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const addDocumentType = (documentType: DocumentType, copyTopicTags = false): Promise<DocumentType> => {
  const params = new URLSearchParams();
  params.append("copytopictags", copyTopicTags.toString());
  return new Promise((resolve, reject) => {
    axios
      .post(`${ServerName}/doctype`, documentType, { params: params })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateDocumentType = (documentType: DocumentType): Promise<DocumentType> => {
  return new Promise((resolve, reject) => {
    axios
      .put(`${ServerName}/doctype/${documentType.id}`, documentType)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteDocumentType = (documentTypeId: string | number): Promise<DocumentType> => {
  return new Promise((resolve, reject) => {
    axios
      .delete(`${ServerName}/doctype/${documentTypeId.toString()}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getTenantConfiguration = async (tenantId: number) => {
  try {
    const response = await axios.get<Tenant>(`${ServerName}/tenantprofile/${tenantId.toString()}`);
    return Promise.resolve(response.data);
  } catch (error: any) {
    return Promise.reject(error);
  }
};

export const onDeleteTenant = async (tenantId: string | number) => {
  tenantId = tenantId.toString();
  if (!tenantId) {
    return Promise.reject();
  }
  if (tenantId === "") {
    return Promise.reject();
  }
  try {
    const response = await axios.delete(`${ServerName}/admin/tenant/${tenantId}`, {
      timeout: 120000,
    });
    return Promise.resolve(response.data);
  } catch (error: any) {
    return Promise.reject(error);
  }
};

export const onDeleteTenantData = async (tenantId: string | number) => {
  tenantId = tenantId.toString();
  if (!tenantId) {
    return Promise.reject();
  }
  if (tenantId === "") {
    return Promise.reject();
  }
  try {
    const response = await axios.delete(`${ServerName}/admin/tenant/${tenantId}/data`, {
      timeout: 120000,
    });
    return Promise.resolve(response.data);
  } catch (error: any) {
    return Promise.reject(error);
  }
};

export const getAllTenants = async () => {
  try {
    const response = await axios.get<Tenant[]>(`${ServerName}/tenantprofile/all`);
    return Promise.resolve(response.data);
  } catch (error: any) {
    return Promise.reject(error);
  }
};
export const updateTenantConfiguration = async (newConfiguration: Tenant) => {
  return axios
    .put<Tenant>(`${ServerName}/tenantprofile/${newConfiguration.id.toString()}`, newConfiguration)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const addNewTenant = (data: Tenant) => {
  return axios
    .post<Tenant>(`${ServerName}/tenantprofile`, data)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const getUserConfiguration = async () => {
  return axios
    .get<UserProfile>(`${ServerName}/user/me`)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
export { getDocumentTypesForTenant };

export const getSystemStatus = async () => {
  try {
    const result = await axios.get<string>(`${ServerName}/monitoring/services`);
    return result.data;
  } catch {
    message.error("Liste der Services kann nicht geladen werden", 5);
    return Promise.reject();
  }
};
